document.addEventListener("DOMContentLoaded", async () => {
    const section = document.querySelector("#mini-driver-intro-page");
    if (!section) return;

    const highlightTextElement = section.querySelector(".highlight-text");
    if (!highlightTextElement) return;

    // const hasPlayedAnimation = sessionStorage.getItem("miniDriverAnimationPlayed");
    // const isPageReloaded = performance.navigation.type === performance.navigation.TYPE_RELOAD;

    // if (hasPlayedAnimation && !isPageReloaded) {
    //     highlightTextElement.classList.add("final");
    //     console.log("Mini Driver animation already played in this session, skipping...");
    //     return;
    // }

    gsap.set([
        highlightTextElement,
        section.querySelector(".kg-driver-subhead"),
        section.querySelector(".kg-driver-subhead-text"),
        section.querySelector(".kg-separator-line"),
        section.querySelector(".text3"),
        section.querySelectorAll(".rotate"),
        section.querySelector(".text2")
    ], { opacity: 0 });

    const { default: SplitType } = await import("https://cdn.skypack.dev/split-type@0.3.3");

    const tlMini = gsap.timeline();

    const splitText = SplitType.create(highlightTextElement, { types: "words" });
    const splitWords = splitText.words;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // 1. Fade in the highlight text first
                tlMini.fromTo(
                    highlightTextElement,
                    { opacity: 0 },
                    { opacity: 1, duration: 1, ease: "linear" }
                );

                // 2. Animate the split words individually
                splitWords.forEach((item, index) => {
                    const width = item.offsetWidth;
                    const dur = width / 100 / 4;
                    tlMini.fromTo(
                        item,
                        { backgroundPosition: "100%" },
                        { backgroundPosition: "0", duration: dur, ease: "linear", stagger: index + 1 }
                    );
                });

                // 3. THEN fade in the H1 after the words have started animating
                tlMini.fromTo(
                    section.querySelector(".kg-driver-subhead"),
                    { opacity: 0 },
                    { opacity: 1, duration: 1, ease: "linear" }
                );

                // 4. Animate Subhead paragraph
                tlMini.fromTo(
                    section.querySelector(".kg-driver-subhead-text"),
                    { opacity: 0 },
                    { opacity: 1, duration: 1.2, ease: "linear" },
                    "-=0.5"
                );

                // 5. Animate Separator Line
                tlMini.fromTo(
                    section.querySelector(".kg-separator-line"),
                    { opacity: 0 },
                    { opacity: 1, duration: 1.6, ease: "linear" },
                    "-=.3"
                );

                // 6. Animate Text3 ("Unlock the power...")
                tlMini.fromTo(
                    section.querySelector(".text3"),
                    { opacity: 0 },
                    { opacity: 1, duration: 1, ease: "linear" },
                    "-=1"
                );

                // 7. Animate Rotate Buttons
                tlMini.fromTo(
                    section.querySelectorAll(".rotate"),
                    { x: -500, opacity: 0 },
                    { x: 0, opacity: 1, duration: 0.4, stagger: 0.3, ease: "power3.out" },
                    "-=0.8"
                );

                // 8. Animate Text2 ("3 face thicknesses...")
                tlMini.fromTo(
                    section.querySelector(".text2"),
                    { opacity: 0 },
                    { opacity: 1, duration: 1, ease: "linear" },
                    "-=0.3"
                );

                observer.unobserve(entry.target);
                sessionStorage.setItem("miniDriverAnimationPlayed", "true");

                tlMini.eventCallback("onComplete", () => {
                    highlightTextElement.classList.add("final");
                });
            }
        });
    });

    observer.observe(highlightTextElement);
});

/* start code added by gagan */
document.addEventListener("DOMContentLoaded", function () {
    console.log("sdaasdasd");
    setTimeout(function () {
        const url = window.location.href;
        const productIdentifiers = [
            "formula-fire-pro-right-hand",
            "formula-fire-pro-left-hand",
        ];
        const loftParam = "attribute_loft=4";

        const isProductMatch = productIdentifiers.some((identifier) =>
            url.includes(identifier)
        );

        if (isProductMatch && url.includes(loftParam)) {
            // Step 2: Find the select element for Loft
            const loftSelect = document.querySelector(
                'select[name="properties[Loft]"]'
            );
            if (loftSelect) {
                for (let option of loftSelect.options) {
                    if (option.value === "10.5°") {
                        option.selected = true;
                        loftSelect.dispatchEvent(new Event("change"));
                        break;
                    }
                }
            }
        }

        const url1 = window.location.href;
        const productIdentifiers1 = ["formula-fire-x-left-hand"];
        const loftParam1 = "attribute_length=2";

        const isProductMatch1 = productIdentifiers1.some((identifier) =>
            url1.includes(identifier)
        );

        if (isProductMatch1 && url1.includes(loftParam1)) {
            const shaftFlexSelects = document.querySelectorAll(
                'select[name="properties[Shaft Flex]"]'
            );

            if (shaftFlexSelects.length > 1) {
                const secondShaftFlexSelect = shaftFlexSelects[1]; // The second select element

                console.log("Second Shaft Flex dropdown found:", secondShaftFlexSelect);

                let isOptionFound = false;
                for (let option of secondShaftFlexSelect.options) {
                    console.log(`Option value: ${option.value}`);
                    if (option.value === "44.5") {
                        option.selected = true;
                        secondShaftFlexSelect.dispatchEvent(new Event("change"));
                        isOptionFound = true;
                        console.log("Option 44.5 selected and change event dispatched.");
                        break;
                    }
                }
                if (!isOptionFound) {
                    console.warn(
                        "Desired option (44.5) not found in the second dropdown."
                    );
                }
            } else {
                console.warn("Second Shaft Flex dropdown not found.");
            }
        }

        const url2 = window.location.href;
        const productIdentifiers12 = ["formula-fire-x-left-hand"];
        const loftParam12 = "attribute_length=4";

        const isProductMatch12 = productIdentifiers12.some((identifier) =>
            url2.includes(identifier)
        );

        if (isProductMatch12 && url2.includes(loftParam12)) {
            const shaftFlexSelects2 = document.querySelectorAll(
                'select[name="properties[Shaft Flex]"]'
            );

            if (shaftFlexSelects2.length > 1) {
                const secondShaftFlexSelect2 = shaftFlexSelects2[1]; // The second select element

                console.log(
                    "Second Shaft Flex dropdown found:",
                    secondShaftFlexSelect2
                );

                let isOptionFound2 = false;
                for (let option2 of secondShaftFlexSelect2.options) {
                    console.log(`Option value: ${option2.value}`);
                    if (option2.value === "45.5 (Standard Length)") {
                        option2.selected = true;
                        secondShaftFlexSelect2.dispatchEvent(new Event("change"));
                        isOptionFound2 = true;
                        console.log(
                            "Option 45.5 (Standard Length) selected and change event dispatched."
                        );
                        break;
                    }
                }

                if (!isOptionFound2) {
                    console.warn(
                        "Desired option (44.5) not found in the second dropdown."
                    );
                }
            } else {
                console.warn("Second Shaft Flex dropdown not found.");
            }
        }
        const url3 = window.location.href;
        const productIdentifiers13 = ["formula-fire-x-left-hand"];
        const loftParam13 = "attribute_grip_size=2";

        const isProductMatch13 = productIdentifiers13.some((identifier) =>
            url3.includes(identifier)
        );

        if (isProductMatch13 && url3.includes(loftParam13)) {
            const shaftFlexSelects3 = document.querySelector(
                'select[name="properties[Grip Size]"]'
            );
            if (shaftFlexSelects3) {
                for (let option of shaftFlexSelects3.options) {
                    if (option.value === "Medium") {
                        option.selected = true;
                        shaftFlexSelects3.dispatchEvent(new Event("change"));
                        break;
                    }
                }
            }
        }
    }, 1000);
    /* end start code added by gagan */
});
